export const CONFIG = {
    API_URL: 'centrofitnesskinesis.it',  // Usa il protocollo completo se necessario
    PROTOCOL: 'https',
    PORT: '4443'
};